interface KeyAccessState {
  [key: string]: any
}

export default function autoMergeLevel2<S extends KeyAccessState>(inboundState: S, reducedState: S): S {
  const newState = { ...reducedState }
  // only rehydrate if inboundState exists and is an object
  if (inboundState && typeof inboundState === 'object') {
    const keys: (keyof S)[] = Object.keys(inboundState)
    keys.forEach((key) => {
      // ignore _persist data
      if (key === '_persist') return
      // if reducer modifies substate, skip auto rehydration
      if (isPlainEnoughObject(reducedState[key])) {
        // if object is plain enough shallow merge the new values (hence "Level2")
        newState[key] = { ...newState[key], ...inboundState[key] }
        return
      }
      // otherwise hard set
      newState[key] = inboundState[key]
    })
  }

  return newState
}

function isPlainEnoughObject(o: unknown) {
  return o !== null && !Array.isArray(o) && typeof o === 'object'
}
